import { ExpiryType, InventoryManagementMethod, LanguageType, OrderType, ThemeMode, TradingSession } from '../../types';
import { atomWithBroadcast } from '../core';

export enum SessionTimeout {
  Timeout15minutes = 'Timeout15minutes',
  Timeout1hour = 'Timeout1hour',
  TimeoutEndOfTheDay = 'TimeoutEndOfTheDay',
  Timeout4hours = 'Timeout4hours',
}

export type OrderDefaults = {
  expiryType: ExpiryType;
  BETTradingSession: TradingSession;
  USATradingSession: TradingSession;
  inventoryManagementMethod: InventoryManagementMethod;
  quantity: number;
  orderType: OrderType;
};

export type UserInterfaceSettings = {
  darkMode: ThemeMode;
  language: LanguageType;
  sessionTimeout: SessionTimeout;
  orderDefaults: OrderDefaults;
};

export const defaultUserInterfaceSettings: UserInterfaceSettings = {
  darkMode: ThemeMode.auto,
  language: LanguageType.Hun,
  sessionTimeout: SessionTimeout.Timeout15minutes,
  orderDefaults: {
    expiryType: ExpiryType.Day,
    BETTradingSession: TradingSession.UnderTrading,
    USATradingSession: TradingSession.Normal,
    inventoryManagementMethod: InventoryManagementMethod.Lifo,
    quantity: 1,
    orderType: OrderType.Limit,
  },
};

export const userInterfaceSettingsAtom = atomWithBroadcast<UserInterfaceSettings>(
  'settings/userInterface',
  defaultUserInterfaceSettings,
);
